import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Axios from "axios"

import _ from 'lodash'


import * as templates from '@/store/templates.js'

import modals from '@/store/modals.js'
import character from '@/store/character.js'
import characters from '@/store/account.characters.js'
import account from '@/store/account.js'

var modules = {
	modals,
	character,
	characters,
	account,
}

const FORMAT_VERSION = 5;

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [
		createPersistedState({
			rehydrated: (store) => {
				if(store.state.account.loggedIn){
					Axios.defaults.headers.common['Authorization'] = 'Bearer '+ store.state.account.accessToken
				}
			}
		}),
	],
	state: {
		Character: templates.zenka,
	},
	getters: {
		formatTitle: () => (input) => {
			return input.replace(/_+/g,' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
		},
		currentLevel: state => {
			return parseInt(state.Character.Level)||1
		},
		usedArmorUpgradeSlots: (state) => {
			var currentArmorID = state.Character.Current.Armor
			var currentArmor = state.Character.Equipment.Armor[ currentArmorID ]
			var armorUpgrades = currentArmor.Upgrades
			var usedSlots = []

			armorUpgrades.forEach( upgrade => {
				if(upgrade.Name != "")
					usedSlots.push(upgrade)
			})

			return usedSlots
		},
		previousLevels: ( state, getters ) => {
			var previousLevels = {}
			var allLevels = state.Character.Levels
			for ( const thisLevel in allLevels ){
				if( thisLevel <= getters.currentLevel )
				previousLevels[thisLevel] = Object.assign( allLevels[thisLevel] )
			}
			return previousLevels
		},
		armorCheck: ( state ) => {
			return parseInt( state.Character.Equipment.Armor[ state.Character.Current.Armor ].ArmorCheck || 0 ) + 
				parseInt( state.Character.Equipment.Shield.ArmorCheck || 0 );
		},
		hasPools: (state, getters) => {
			return (state.Character.Levels[ getters.currentLevel ].Pools !== undefined)
		},
		updateFormat: () => (characterData) => {
			var character = JSON.parse(characterData)

			switch(character.Version){
				case undefined:
					// fall through

				case 0:
					//Update Ability Scores to be separate fields
					var blankAbilityScores = {
						"Strength": 0,
						"Dexterity": 0,
						"Constitution": 0,
						"Intelligence": 0,
						"Wisdom": 0,
						"Charisma": 0
					};
					character.AbilityScores.Base = Object.assign({}, character.AbilityScores);
					character.AbilityScores.Race = Object.assign({}, blankAbilityScores);
					character.AbilityScores.Theme = Object.assign({}, blankAbilityScores);
					character.AbilityScores.Upgrades = Object.assign({}, blankAbilityScores);
					character.AbilityScores.Temporary = Object.assign({}, blankAbilityScores);
		
					//Add some miscelaneous fields for version/revision/system tracking.
					character.Version = 1;
					character.System = 'sfrpg';
		
					//Add an AbilityIncreases to each Level that's a multiple of 5
					Object.keys(character.Levels).forEach(function(key){
						if(key % 5 == 0){
							character.Levels[key].AbilityIncreases = blankAbilityScores;
						}
					});
		
					//remove old Ability Scores
					delete character.AbilityScores.Strength; 
					delete character.AbilityScores.Dexterity;
					delete character.AbilityScores.Constitution;
					delete character.AbilityScores.Intelligence;
					delete character.AbilityScores.Wisdom;
					delete character.AbilityScores.Charisma;
		
					character.Version = 1;
					// fall through

				case 1:
					//THINGS HAPPENING TO EACH LEVEL:
					//Convert Skills to SkillRanks, then add the new Skills object.
					var needsSkillUpdate = false;
		
					Object.keys(character.Levels).forEach(function(key){
						var level = character.Levels[key];
						if(typeof(level.Skills) == "number"){
							needsSkillUpdate = true;
							level.SkillRanks = level.Skills.valueOf();
							level.Skills = {
								"Acrobatics": 0,
								"Athletics": 0,
								"Bluff": 0,
								"Computers": 0,
								"Culture": 0,
								"Diplomacy": 0,
								"Disguise": 0,
								"Engineering": 0,
								"Intimidate": 0,
								"Life Science": 0,
								"Medicine": 0,
								"Mysticism": 0,
								"Perception": 0,
								"Physical Science": 0,
								"Piloting": 0,
								"Profession1": 0,
								"Profession2": 0,
								"Sense Motive": 0,
								"Sleight of Hand": 0,
								"Stealth": 0,
								"Survival": 0
							};
						}
					});
		
					//Put the current Ranks into the Skills for first level, then remove Ranks
					Object.keys(character.Skills).forEach(function(key){
						if(needsSkillUpdate){
							character.Levels[1].Skills[key] = character.Skills[key].Ranks.valueOf();
						}
						delete character.Skills[key].Ranks;
					});
		
					//Rebuild Bio, Adding a Languages component to Bio
					character.Bio = Object.assign({},
						{"Character Name":character.Bio["Character Name"]},
						{"Class / Levels":character.Bio["Class / Levels"]},
						{"Gender":character.Bio["Gender"]},
						{"Theme":character.Bio["Theme"]},
						{"Speed":character.Bio["Speed"]},
						{"Homeworld":character.Bio["Homeworld"]},
						{"Languages":""},
						{"Alignment":character.Bio["Alignment"]},
						{"Deity":character.Bio["Deity"]},
						{"Player":character.Bio["Player"]},
						{"Image":character.Bio["Image"]},
						{"Race":character.Bio["Race"]}
					);
		
					character.Version = 2;
					// fall through
		
				case 2:		
					Object.keys(character.Levels).forEach(function(key){
						var level = character.Levels[key];
						if(typeof(level.Feats) == 'undefined'){
							level.Feats = [];
							if(level.Feat){
								level.Feats.push(level.Feat);
								delete level.Feat;
							}
						}
					});
					if(typeof(character.Misc.CastingStat) == "undefined"){
						character.Misc.CastingStat = "";
					} 
					if(typeof(character.Misc.SpellSaveDCMod) == "undefined"){
						character.Misc.SpellSaveDCMod = 0;
					} 
					
					character.Version = 3;
					// fall through
		
				case 3:
					//Rename "Class / Levels" to ShortDescription and add LongDescription
					if(typeof(character.Bio.ShortDescription) == "undefined"){
						character.Bio.ShortDescription = character.Bio['Class / Levels'];
						delete character.Bio['Class / Levels'];
					}
					if(typeof(character.Bio.LongDescription) == "undefined"){
						character.Bio.LongDescription = "";
					}
		
					//Convert Armor to an array, add CurrentArmor = 0
					if(! Array.isArray(character.Armor) ){
						var armorArray = [Object.assign({},character.Armor)];
						character.Armor = armorArray;
						character.CurrentArmor = 0;
					}
		
					//Add Price/Bulk to Equipped Items, Augmentations, Magic Items, & Armor Upgrades
					character.Equipment.Equipped.forEach(function(item){
						if(typeof(item.Price) == "undefined" && typeof(item.Bulk) == "undefined"){
							item.Price = 0;
							item.Bulk = 0;
						}
		
					});
					character.Equipment.Augmentation.forEach(function(item){
						if(typeof(item.Price) == "undefined"){
							item.Price = 0;
						}
					});
					character.Equipment.Magic.forEach(function(item){
						if(typeof(item.Price) == "undefined" && typeof(item.Bulk) == "undefined"){
							item.Price = 0;
							item.Bulk = 0;
						}
					});
					if( typeof(character.Armor[0].Upgrades) != "undefined" ){
						character.Armor[0].Upgrades.forEach(function(item){
							if(typeof(item.Price) == "undefined"){
								item.Price = 0;
							}
							if(typeof(item.Bulk) == "undefined"){
								item.Bulk = 0;
							}
						});
					}
		
					//Add temporaryHitPoints
					if(typeof(character.temporaryHitPoints) == "undefined"){
						character.temporaryHitPoints = {
							Max: 0,
							Current: 0,
							Heal: 0,
							Active: false,
						}
					}
		
					//Remove HasCompanion option
					if(typeof(character.Misc.HasCompanion) != "undefined"){
						delete character.Misc.HasCompanion;
					}
				
					//Add Shield if not there
					if(typeof(character.Equipment.Shield) == "undefined"){
						character.Equipment.Shield = {
							Level: 1,
							Name: '',
							Price: 0,
							BonusWielded: 0,
							BonusAligned: 0,
							MaxDex: 0,
							ArmorCheck: 0,
							Bulk: 0,
							UpgradeSlots: 0,
							Upgrades: []
						}
					}
		
					//Move Weapons to Equipment.Weapons
					if(typeof(character.Equipment.Weapons) == "undefined"){
						var weapons = character.Weapons.slice();
						character.Equipment.Weapons = weapons;
						delete character.Weapons;
					}
		
					if(typeof(character.Equipment.Armor) == "undefined"){
						var armor = character.Armor.slice();
						character.Equipment.Armor = armor;
						delete character.Armor;
					}
		
					//For some reason, some characters haven't gotten this?
					if(typeof(character.Misc.CastingStat) == "undefined"){
						character.Misc.CastingStat = "";
					} 
					if(typeof(character.Misc.SpellSaveDCMod) == "undefined"){
						character.Misc.SpellSaveDCMod = 0;
					}
		
					//CurrentLevel > Level
					if(typeof(character.Level) == "undefined"){
						character.Level = character.CurrentLevel;
						delete character.CurrentLevel;
					}
		
					//Create the Current object, populate it
					if(typeof(character.Current) == "undefined"){
						character.Current = {
							"Ammunition": [],
							"Armor": character.CurrentArmor,
							"Points": {
								"Hit": character.CurrentHitPoints,
								"Stamina": character.CurrentStaminaPoints,
								"Resolve": character.CurrentResolvePoints,
								"Temporary": {
									"Active": character.temporaryHitPoints.Active,
									"HP": character.temporaryHitPoints.Current,
									"Heal": character.temporaryHitPoints.Heal,
									"Max": character.temporaryHitPoints.Max,
								}
							}
						};
						delete character.CurrentLevel;
						delete character.CurrentHitPoints;
						delete character.CurrentStaminaPoints;
						delete character.CurrentResolvePoints;
						delete character.CurrentArmor;
						delete character.temporaryHitPoints;
						//Populate Ammunition
						character.Current.Ammunition.length = character.Equipment.Weapons.length;
						character.Equipment.Weapons.forEach(function(weapon, index){
							character.Current.Ammunition[index] = weapon.Capacity||0;
						});
						//Check for Drone HP
						if(typeof(character.DroneCurrentHitPoints) !== "undefined"){
							character.Current.Drone = {
								"Points": {
									"Hit": character.DroneCurrentHitPoints,
								}
							};
							delete character.DroneCurrentHitPoints;
						}
						//Check for Drone RP
						if(typeof(character.DroneCurrentResolvePoints) !== "undefined"){
							character.Current.Drone.Points["Resolve"] = character.DroneCurrentResolvePoints;
							delete character.DroneCurrentResolvePoints;
						}
						//Check for Companion HP
						if(typeof(character.CompanionCurrentHitPoints) !== "undefined"){
							character.Current.Companion = {
								"Points": {
									"Hit": character.CompanionCurrentHitPoints,
								}
							};
							delete character.CompanionCurrentHitPoints;
						}
					}
		
					if(typeof(character.Current.SpellSlots) == "undefined"){
						character.Current.SpellSlots = {};
						Object.keys(character.Levels[character.Level].Spells.PerDay).forEach(function(level){
							character.Current.SpellSlots[0] = 0;
							character.Current.SpellSlots[level] = character.Levels[character.Level].Spells.PerDay[level];
						});
					}
					
					//Uncomment below when done adding new bits.
					character.Version = 4;
					// fall through
		
				default:
					//These changes will become v5

					if(Array.isArray(character.Current.Ammunition)){
						let ammunition = {...character.Current.Ammunition}
						character.Current.Ammunition = ammunition
					}

					break;
			}
		
			return character;
		}
	},
	mutations: {
		startOver (state) {
			state.Character = templates.blank
		},
		loadZenka (state) {
			state.Character = templates.zenka
		},
		loadCharacter (state, character) {
			if(character.Version == 4){
				state.Character = character
			}
		},
		setCharacterProp (state, payload) {
			//todo take an object of properties and values,
			//iterate through them, and use _.setWIth(blah, blah, blah, Object)
			//to setup the object to merge with state.Character
			/*eslint-disable no-console*/
			if(Array.isArray(payload)){
				var updates = {}
				payload.forEach( (update) => {
					_.setWith(updates, update.key, update.val, Object)
				})
				Object.assign( {},
					_.merge( state.Character, updates )
				)
			}
			else {
				Object.assign( {},
					_.merge( state.Character, payload )
				)
			}
		},
	},
	actions: {
		loadCharacter ( {commit, dispatch, getters} , characterData) {
			var character = JSON.parse(characterData)

			if(character.Version == FORMAT_VERSION){
				delete character.Armor
				commit(
					'loadCharacter',
					character
				)
			} else {
				commit(
					'loadCharacter', 
					getters.updateFormat( characterData )
				)
			}
			for(var submodule in modules){
				if(this._actions[`${submodule}/loadCharacter`]){
					dispatch(`${submodule}/loadCharacter`, character, {root:true})
				}
			}
		},
	},
	modules: modules,
})